import { render, staticRenderFns } from "./settingEmail.vue?vue&type=template&id=63401455&scoped=true"
import script from "./settingEmail.vue?vue&type=script&lang=js"
export * from "./settingEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63401455",
  null
  
)

export default component.exports